import colors from '../tokens/colors';

export const linkGetolo = {
  base: {
    border: {
      radius: 4,
    },
    outline: {
      size: '3px solid',
      color: 'transparent',
    },
  },
  states: {
    focusVisible: {
      outlineColor: colors.PROFESSIONAL_BLUE,
    },
  },
};

export const linkDaDirekt = {
  base: {
    border: {
      radius: 4,
    },
    outline: {
      size: '2px solid',
      color: 'transparent',
    },
  },
  states: {
    focusVisible: {
      outlineColor: colors.DA_DIREKT_VISUAL_BRAND_ORANGE,
    },
  },
};

export const linkDaKaufland = {
  base: {
    border: {
      radius: 0,
    },
    outline: {
      size: '2px solid',
      color: 'transparent',
    },
  },
  states: {
    focusVisible: {
      outlineColor: colors.DA_KAUFLAND_RED,
    },
  },
};

export const linkFressnapf = {
  base: {
    border: {
      radius: 0,
    },
    outline: {
      size: 'none',
      color: 'transparent',
    },
  },
  states: {
    focusVisible: {
      outlineColor: 'transparent',
    },
  },
};
